require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./waiting-for-paradise.json") })
        }
      }, "path---waiting-for-paradise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---waiting-for-paradise!./.cache/json/waiting-for-paradise.json
// module id = 582
// module chunks = 231608221292675